import { type ThemeAppearance } from '@atlaskit/lozenge';

import { goalStatusValues } from '../constants';

export const getGoalStatusAppearance = (status: string): ThemeAppearance => {
	switch (status) {
		case goalStatusValues.ON_TRACK:
			return 'success';
		case goalStatusValues.AT_RISK:
			return 'moved';
		case goalStatusValues.OFF_TRACK:
			return 'removed';
		default:
			return 'default';
	}
};
